// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__kv-u3","header":"ReportDetails_header__3dD_q","title":"ReportDetails_title__1BwMy","left":"ReportDetails_left__2jRCm"};